interface StepCardProps {
  step: number;
  title: string;
  description: string;
}

export function StepCard({ step, title, description }: StepCardProps) {
  return (
    <div className="flex flex-col items-center text-center">
      <div className="relative mb-4">
        <div className="flex size-12 items-center justify-center rounded-sm bg-peninsula-magma text-white font-bold text-lg">
          {step}
        </div>
        <div className="absolute -bottom-1.5 left-1/2 h-0.5 w-6 -translate-x-1/2 bg-peninsula-magma" aria-hidden="true" />
      </div>
      <h3 className="text-lg font-semibold mb-2">{title}</h3>
      <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
        {description}
      </p>
    </div>
  );
}
